import { useQuery } from "@tanstack/react-query"
import { api } from "../../../lib/api/client"
import { extractArray } from "../../../lib/api/response-utils"
import { billingCategoriesKeys } from "../../../lib/query-keys"
import type { BillingCategory } from "../types"

export function useBillingCategories(division: string | undefined) {
  return useQuery({
    queryKey: billingCategoriesKeys.division(division || ""),
    queryFn: async () => {
      if (!division) throw new Error("Division is required")
      const response = await api.billingCategories.find(division)
      return extractArray<BillingCategory>(response)
    },
    enabled: !!division,
  })
}
